getCurrentPlanPrice